import { JwoStoreManagementGateway as Client } from '@amzn/coral_com-amazon-jwostoremanagementgateway'
import { JwoStoreManagementGatewayClientConfigFactory } from '@amzn/coral-config_jwo-store-management-gateway'
import { CoralClientFactory } from '@amzn/ihm-js-coral-client'
import { EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'
import { BasicCoralHandler } from '@coral/BasicCoralHandler'
import { getActiveRealm } from '@utils/RegionRealms'

/**
 * Coral qualifier for an explicit realm.
 *
 * @throws if the realm maps to no cell, rather than letting Coral fail further downstream with
 *   the much less diagnosable CoralClientConfigNotFound.
 */
export const getQualifierForRealm = (realm: string | undefined): string => {
    const domain = EnvironmentDetail.getDomain()
    if (!realm) {
        throw new Error(`No gateway cell for the current region (domain '${domain}')`)
    }
    return `${domain}.${realm}`
}

/** Coral qualifier for the cell this session should currently be talking to. */
export const getQualifier = (): string => getQualifierForRealm(getActiveRealm())

/**
 * Creates an unauthenticated Gateway client for token operations.
 * Does not add auth headers - used for token exchange.
 */
export function createUnauthenticatedGatewayClient (): Client {
    return createUnauthenticatedGatewayClientForRealm(getActiveRealm())
}

/**
 * As createUnauthenticatedGatewayClient, but targeting an explicit realm without reading or
 * mutating the session's own region — safe for probing a peer cell while unrelated calls are in
 * flight. Not cached; construction performs no I/O.
 */
export function createUnauthenticatedGatewayClientForRealm (realm: string | undefined): Client {
    return new CoralClientFactory(
        [JwoStoreManagementGatewayClientConfigFactory],
        getQualifierForRealm(realm),
        new BasicCoralHandler(),
        [],
    ).get(Client)
}
